export const END_POINTS = {
  AUTH: {
    USER: "admin/profile",
    LOGIN: "admin/login",
    VERIFY: "admin/verify",
    FORGOT_PASSWORD: "admin/forgot-password",
    RESET_PASSWORD: "admin/reset-password",
    SIGN_S3_URL: (url: string) => `auth/pre-signed-url?url=${url}`,
  },
  BUSINESS: {
    REQUESTS: (
      page: number,
      limit: number,
      status: string,
      businessname: string,
      gst: string,
      email: string,
      mobile: string,
    ) =>
      `admin/users?page=${page}&limit=${limit}&status=${status}&businessname=${businessname}&gst=${gst}&email=${email}&mobile=${mobile}`,
    USER_BY_ID: (id: string) => `admin/users/${id}`,
    ACTION_OTP_ON_RQUEST: (id: string) => `admin/users/verify/${id}`,
    ACTION_OTP_VERIFY_ON_RQUEST: (id: string) => `admin/users/verify/otp/${id}`,
    CONNECTION_LIST: (
      id: string,
      identifier: string,
      page: number = 1,
      limit: number = 100,
    ) =>
      `admin/connections/${id}?page=${page}&limit=${limit}&identifier=${identifier}`,
  },
  NOTIFICATION: {
    GET: (page: number, limit: number) =>
      `notification?page=${page}&limit=${limit}`,
    MARK_ALL_AS_READ: `notification/read`,
    UNREAD_COUNT: `notification/unread-count`,
    MARK_AS_OPEN: (id: string) => `notification/open/${id}`,
  },
  INVOICE: {
    LIST: (
      page: number,
      limit: number,
      status: string,
      buyer: string,
      seller: string,
      buyergst: string,
      sellergst: string,
      search: string,
      createdStartDate: string,
      createdEndDate: string,
      approvedStartDate: string,
      approvedEndDate: string,
    ) =>
      `admin/invoice-requests?page=${page}&limit=${limit}&status=${status}&buyer=${buyer}&seller=${seller}&buyergst=${buyergst}&sellergst=${sellergst}&search=${search}&createdStartDate=${createdStartDate}&createdEndDate=${createdEndDate}&approvedStartDate=${approvedStartDate}&approvedEndDate=${approvedEndDate}`,
  },
  ACCOUNTING: {
    LIST: (
      page: number,
      limit: number,
      id: string,
      buyer: string,
      seller: string,
      startDate: string,
      endDate: string,
    ) =>
      `admin/transactions?page=${page}&limit=${limit}&id=${id}&buyer=${buyer}&seller=${seller}&startDate=${startDate}&endDate=${endDate}`,
  },

  AFFILIATE: {
    CREATE: `user/affiliate/create`,
    LIST: (
      page: number,
      limit: number,
      panNumber: string,
      gstNumber: string,
      firstName: string,
      lastName: string,
      email: string,
      phone: string,
      username: string,
    ) =>
      `user/affiliates?page=${page}&limit=${limit}&panNumber=${panNumber}&gstNumber=${gstNumber}&firstName=${firstName}&lastName=${lastName}&email=${email}&phone=${phone}&username=${username}`,
    TIER: {
      CREATE: `admin/tiers`,
      UPDATE: (id: string) => `admin/tiers/${id}`,
      GET: `admin/tiers`,
    },
    SETTLEMENT: {
      GET: (page: number, limit: number) =>
        `admin/affiliate/unsettled-commissions?page=${page}&limit=${limit}`,
      GET_HISTORY: (page: number, limit: number) =>
        `admin/affiliate/settlement-records?page=${page}&limit=${limit}&affiliateId`,
      GET_AFFILIATE_BANKS: (id: string) => `affiliate-banks/admin/${id}`,
      SETLLE_AMOUNT: (id: string) => `admin/affiliate/settle-commission/${id}`,
    },
    GET_AFFILIATE_INVITATIONS: (
      page: number,
      limit: number,
      affiliateId: string,
      startDate: string,
      endDate: string,
      status: string,
    ) =>
      `admin/affiliate/invitations?page=${page}&limit=${limit}&affiliateId=${affiliateId}&startDate=${startDate}&endDate=${endDate}&status=${status}`,
    ANALYTICS: `auth/admin-affiliate-dashboard?startDate=2025-01-01&endDate=2025-12-30`,
  },
  SALES: {
    CREATE: `sales-user`,
    GET_REGION_AND_TERITORY: `sales-user/region`,
    LIST: (page: number, limit: number, search: string) =>
      `sales-user?page=${page}&limit=${limit}&search=${search || ""}`,
    UPDATE: (id: string) => `sales-user/${id}`,
    DASHBOARD: `sales-user/admin-dashboard`,
    SALES_ROLE: `role/all`,
    AFFILIATES: (page: number, limit: number, salesUserId: string) =>
      `admin/sales-user/created-affiliates?salesUserId=${salesUserId}&page=${page}&limit=${limit}`,
    MANAGERS: (regionId: string, includeTeamCount: boolean = false) =>
      `sales-user/managers?regionId=${regionId}&includeTeamCount=${includeTeamCount}`,
    INCENTIVE_PLAN: {
      CREATE: `sales-incentive-plan`,
      LIST: `sales-incentive-plan`,
      UPDATE: (id: string) => `sales-incentive-plan/${id}`,
    },
    SETTLEMENT: {
      GET: (page: number, limit: number) =>
        `admin/sales/unsettled-commissions?page=${page}&limit=${limit}`,
      GET_SALES_SETTLEMENT_HISTORY: (page: number, limit: number, id: string) =>
        `admin/sales-user/settlement-records?page=${page}&limit=${limit}&salesUserId=${id}`,
      GET_DEFAULT_BANK: (id: string) => `user-sales-banks/default/${id}`,
      GET_AFFILIATE_BANKS: (id: string) => `user-sales-banks/admin/${id}`,
      SETLLE_AMOUNT: (id: string) => `admin/sales/settle-commission/${id}`,
    },
  },
  BILLING: {
    LIST: (
      page: number,
      limit: number,
      userId: string,
      status: string,
      startDate: string,
      endDate: string,
    ) =>
      `admin/billing-records?page=${page}&limit=${limit}&status=${status}&userId=${userId}&startDate=${startDate}&endDate=${endDate}`,
    UPDATE: (id: string, remarks: string) =>
      `admin/billing-records/${id}/FAILED?remarks=${remarks}`,
  },
  FEE: {
    LIST: (
      page: number,
      limit: number,
      businessgst: string,
      businessname: string,
      status: string,
      type: string,
      startDate: string,
      endDate: string,
    ) =>
      `admin/fees?page=${page}&limit=${limit}&businessgst=${businessgst}&businessname=${businessname}&status=${status}&type=${type}&startDate=${startDate}&endDate=${endDate}`,
  },
  ADMIN_CONTROLS: {
    GET: `admin/controls`,
    UPDATE: `admin/controls`,
    BATCH_PROCESS: `admin/batch-process`,
    BILL_ENGINE: `admin/bill-engine`,
    SERVICES_CONTROL: {
      LIST: "service-info",
      TOGGLE: (id: string) => `service-info/toggle-kyc/${id}`,
    },
  },
  ACTIVITY: {
    GET: (
      page: number,
      limit: number,
      user: string,
      startDate: string,
      endDate: string,
      category: string,
      type: string,
    ) =>
      `admin/activities?page=${page}&limit=${limit}&user=${user}&startDate=${startDate}&endDate=${endDate}&category=${category}&type=${type}`,
  },
  LEADS: {
    GET: (params: string) => `leads?${params}`,
    CREATE: "leads",
    UPDATE: (id: string) => `leads/${id}`,
    BULK_UPLOAD: "leads/bulk-upload",
    TRANSFER_LEAD: "admin/assign-lead",
  },
  CHAT: {
    GET: (id: string) => `admin/chat-transcript/${id}`,
  },
  BANK_LOGS: (
    page: number,
    limit: number,
    type: string,
    invoicerequest: string,
  ) =>
    `admin/bank-api-logs?page=${page}&limit=${limit}&type=${type}&invoicerequest=${invoicerequest}`,
  TICKET: {
    LIST: (
      page: number,
      limit: number,
      status: string,
      priority: string,
      type: string,
      category: string,
    ) =>
      `ticket?page=${page}&limit=${limit}&status=${status}&priority=${priority}&type=${type}&category=${category}`,
    TICKET_TYPE: `ticket/type`,
    TICKET_CATEGORY_ALL: `ticket/category`,
    TICKET_CATEGORY: `ticket/get-category`,
    TICKET_SUB_CATEGORY: `ticket/get-subcategory`,
    TICKET_DETAIL: (id: string) => `ticket/${id}`,
    UPDATE_TICKET_STATUS: (id: string) => `ticket/status/${id}`,
    TOGGLE_TICKET_FLAG: (id: string) => `ticket/flag/${id}`,
    ADD_TICKET_TAGS: (id: string) => `ticket/add-tag/${id}`,
    ADD_TICKET_WORKFLOW: (id: string) => `ticket/add-workflow/${id}`,
    CLEAR_TICKET_WORKFLOW: (id: string) => `ticket/clear-workflow/${id}`,
    SEND_MESSAGE: (id: string) => `ticket/message-admin/${id}`,
  },
};
